import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { createStyleSheet, asCSSUrl } from '../../../../base/browser/dom.js';
import { DisposableStore } from '../../../../base/common/lifecycle.js';
import { IConfigurationService } from '../../../../platform/configuration/common/configuration.service.js';
import { LifecyclePhase } from '../../../services/lifecycle/common/lifecycle.js';
import { ILifecycleService } from '../../../services/lifecycle/common/lifecycle.service.js';
let WebviewIconManager = class WebviewIconManager {
    constructor(_lifecycleService, _configService) {
        this._lifecycleService = _lifecycleService;
        this._configService = _configService;
        this._icons = ( new Map());
        this._configService.onDidChangeConfiguration(e => {
            if (e.affectsConfiguration('workbench.iconTheme')) {
                this.updateStyleSheet();
            }
        });
    }
    dispose() {
        this._styleElementDisposable?.dispose();
        this._styleElementDisposable = undefined;
        this._styleElement = undefined;
    }
    get styleElement() {
        if (!this._styleElement) {
            this._styleElementDisposable = ( new DisposableStore());
            this._styleElement = createStyleSheet(undefined, undefined, this._styleElementDisposable);
            this._styleElement.className = 'webview-icons';
        }
        return this._styleElement;
    }
    setIcons(webviewId, iconPath) {
        if (iconPath) {
            this._icons.set(webviewId, iconPath);
        }
        else {
            this._icons.delete(webviewId);
        }
        this.updateStyleSheet();
    }
    async updateStyleSheet() {
        await this._lifecycleService.when(LifecyclePhase.Starting);
        const cssRules = [];
        if (this._configService.getValue('workbench.iconTheme') !== null) {
            for (const [key, value] of this._icons) {
                const webviewSelector = `.show-file-icons .webview-${key}-name-file-icon::before`;
                try {
                    cssRules.push(`.monaco-workbench.vs ${webviewSelector}, .monaco-workbench.hc-light ${webviewSelector} { content: ""; background-image: ${asCSSUrl(value.light)}; }`, `.monaco-workbench.vs-dark ${webviewSelector}, .monaco-workbench.hc-black ${webviewSelector} { content: ""; background-image: ${asCSSUrl(value.dark)}; }`);
                }
                catch {
                }
            }
        }
        this.styleElement.textContent = cssRules.join('\n');
    }
};
WebviewIconManager = ( __decorate([
    ( __param(0, ILifecycleService)),
    ( __param(1, IConfigurationService))
], WebviewIconManager));
export { WebviewIconManager };
